import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'core/components/ErrorBoundary';
import ResponsiveProvider from 'core/providers/ResponsiveProvider';
import { CartProvider } from 'core/providers/CartContext';

/**
 * Entry point container at the top of the React tree.
 * child node is wrapped with ErrorBoundary & ResponsiveProvider
 *
 * @param {children} Component Page-level, top of the tree
 */
const EntryContainer = ({ children }) => {
	return (
		<ErrorBoundary>
			<ResponsiveProvider>
				<CartProvider>
					{ children }
				</CartProvider>
			</ResponsiveProvider>
		</ErrorBoundary>
	);
};

// This one doesn't use `ResponsiveProvider`
export const BasicEntryContainer = ({ children, activeCartId }) => {
	return (
		<ErrorBoundary>
			<CartProvider value={{ activeCartId }}>
				{ children }
			</CartProvider>
		</ErrorBoundary>
	);
};

BasicEntryContainer.defaultProps = {
	children: null,
	activeCartId: null,
};

BasicEntryContainer.propTypes = {
	children: PropTypes.node,
	activeCartId: PropTypes.number,
};

EntryContainer.propTypes = {
	children: PropTypes.node.isRequired
};

export default EntryContainer;
